<template>
  <div class="nybanner">
    <img :src="baseApi + '/upload/Banner/2017082218254724.jpg'" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/us/componets/Banner.vue